import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Mail, Award, ShieldCheck } from 'lucide-react';
import { GlassCard } from './GlassCard';
import { SectionHeading } from './SectionHeading';
const faculty = [{
  name: 'Dr. Sarah Chen',
  role: 'Lead GRC Instructor',
  img: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm4-img1.jpg',
  certs: ['CISA', 'CRISC'],
  specialization: 'Governance & Risk'
}, {
  name: 'Marcus Thorne',
  role: 'Cyber Resilience Expert',
  img: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm4-img2.jpg',
  certs: ['CISSP', 'CEH'],
  specialization: 'Threat Intelligence'
}, {
  name: 'Elena Rodriguez',
  role: 'Data Privacy Lead',
  img: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm4-img5.jpg',
  certs: ['CIPP/E', 'CIPM'],
  specialization: 'Privacy & Compliance'
}, {
  name: 'David Okoro',
  role: 'Security Operations',
  img: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm4-img6.jpg',
  certs: ['Security+', 'CySA+'],
  specialization: 'SOC Operations'
}];
export function FacultySection() {
  return <section className="py-24 bg-background-secondary/30" data-id="element-62">
      <div className="container mx-auto px-6" data-id="element-63">
        <SectionHeading title="World-Class Faculty" subtitle="Learn from industry practitioners who are actively defending global enterprises." data-id="element-64" />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-65">
          {faculty.map((member, i) => <motion.div key={member.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-66">
              <GlassCard className="group p-0 overflow-hidden border-white/5 hover:border-primary-blue/30 transition-all duration-500" data-id="element-67">
                <div className="relative aspect-square overflow-hidden" data-id="element-68">
                  <img src={member.img} alt={member.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-110" data-id="element-69" />
                  <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent opacity-60" data-id="element-70" />

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-primary-blue/80 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col items-center justify-center p-6 text-center" data-id="element-71">
                    <div className="mb-4 flex gap-3" data-id="element-72">
                      <a href="#" className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white hover:bg-white transition-colors hover:text-primary-blue" data-id="element-73">
                        <Linkedin size={20} data-id="element-74" />
                      </a>
                      <a href="#" className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white hover:bg-white transition-colors hover:text-primary-blue" data-id="element-75">
                        <Mail size={20} data-id="element-76" />
                      </a>
                    </div>
                    <div className="text-xs font-bold text-white/70 uppercase tracking-widest mb-2" data-id="element-77">
                      Specialization
                    </div>
                    <div className="text-white font-bold" data-id="element-78">
                      {member.specialization}
                    </div>
                  </div>
                </div>

                <div className="p-6" data-id="element-79">
                  <h3 className="text-xl font-bold text-white mb-1" data-id="element-80">
                    {member.name}
                  </h3>
                  <p className="text-primary-blue text-sm font-medium mb-4" data-id="element-81">
                    {member.role}
                  </p>

                  <div className="flex flex-wrap gap-2" data-id="element-82">
                    {member.certs.map(cert => <div key={cert} className="flex items-center gap-1 px-2 py-1 rounded bg-white/5 border border-white/10 text-[10px] font-bold text-white/60" data-id="element-83">
                        <ShieldCheck size={10} className="text-primary-blue" data-id="element-84" />
                        {cert}
                      </div>)}
                  </div>
                </div>
              </GlassCard>
            </motion.div>)}
        </div>
      </div>
    </section>;
}